import React from "react"

import * as style from "./Detail.module.scss"

const Detail = ({ param, microcopy }) => (
  <div className={style.details}>
    {param.pattern && (
      <div>
        <label>{microcopy.text("reference.parameter_details.pattern")}</label>
        <code>{param.pattern}</code>
      </div>
    )}
    {param.example && !param.hasAdditionalProperties
      && !(param.key === "box-version" && param.location === "header") && (
      <div>
        <label>{microcopy.text("reference.parameter_details.example")}</label>
        <code>{param.location === "body" && param.type === "string" ? `"${param.example}"` : param.example}</code>
      </div>
    )}
    {param.default && (
      <div>
        <label>{microcopy.text("reference.parameter_details.default")}</label>
        <code>{param.default}</code>
      </div>
    )}
    {param.minValue && (
      <div>
        <label>{microcopy.text("reference.parameter_details.min_value")}</label>
        <code>{param.minValue}</code>
      </div>
    )}

    {param.maxValue && (
      <div>
        <label>{microcopy.text("reference.parameter_details.max_value")}</label>
        <code>{param.maxValue}</code>
      </div>
    )}

    {param.maxLength && (
      <div>
        <label>
          {microcopy.text("reference.parameter_details.max_length")}
        </label>
        <code>{param.maxLength}</code>
      </div>
    )}
  </div>
)

export default Detail
